import React, { useEffect, useState } from "react";
import { CircleIcon, Flex } from "@fluentui/react-northstar";
import { slaColor } from "../common/textOperations";
import ISLATimer from "../interfaces/ISLATimer";
import Countdown from "./countdown";

const SLATimer: React.FC<ISLATimer> = ({ name, terminalStateReached, status, warningTime, failureTime }) => {
    const [nr, setNr] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => { setNr(nr + 1); }, 1000);
        return () => clearInterval(timer);
    });

    return (
        <Flex column style={{ color: slaColor(status, terminalStateReached, warningTime, failureTime) }}>
            <small>{name}</small>
            <Flex gap="gap.smaller">
                <CircleIcon size="smaller" style={{ marginTop: 5 }} />
                <div>{terminalStateReached ? status : <Countdown endtime={failureTime} />}</div>
            </Flex>
        </Flex>
    );
};

export default SLATimer;
